import { defaultSettings } from './state.js'
import Vue from 'vue'
// const { filters } = defaultSettings

const createMutations = (mutations = {}) =>
  Object.assign(
    {},
    {
      SET_FILTER (state, { field, value }) {
        Vue.set(state.settings.filters, field, value)
      },
      SET_FILTER_LETTER (state, { letter, value }) {
        Vue.set(state.settings.filters.letters, letter, value)
        /*
    let selectedLetters = state.invoiceAddress.filters.letters
    if (!value && selectedLetters[letter]) {
      // console.log('> remove letter', letter)
      delete selectedLetters[letter]
      state.invoiceAddress.filters = Object.assign({}, state.invoiceAddress.filters)
    } else {
      state.invoiceAddress.filters.letters = Object.assign({}, state.invoiceAddress.filters.letters, {
        [letter]: true
      })
    }
    */
      },
      SET_COLUMN_FILTER (state, { field, value }) {
        Vue.set(state.settings.filters.columns, field, value)
      },
      SET_QUICK_EDIT (state, payload) {
        Vue.set(state, 'quickEditId', payload)
      },
      CLEAR_COLUMN_FILTER (state, field) {
        Vue.set(state.settings.filters.columns, field, null)
      },
      FILTERS_CLEAR (state) {
        Vue.set(state, 'settings', Object.assign({}, defaultSettings))
      },
      SET_LAYOUT (state, payload) {
        Vue.set(state.settings, 'layout', payload)
      },
      SET_PAGINATION (state, payload) {
        Vue.set(state.settings, 'pagination', payload)
      },
      SET_TOTAL_RESULTS (state, payload) {
        Vue.set(state.settings.pagination, 'rowsNumber', payload)
      },
      SET_VISIBLE_COLUMNS (state, payload) {
        Vue.set(state.settings, 'visibleColumns', payload)
      },
      HIDE_COLUMN (state, column) {
        if (state.settings.visibleColumns[column]) {
          Vue.set(state.settings.visibleColumns, column, false)
        }
      },
      SET_SEARCH (state, value) {
        Vue.set(state.settings.filters, 'search', value)
      },
      SORT (state, { field, direction }) {
        Vue.set(state.settings, 'sortField', field)
        Vue.set(state.settings, 'sortDirection', direction)
        /*
    state.invoiceAddress = Object.assign({}, state.invoiceAddress, {
      sortField: field,
      sortDirection: direction
    })
    */
      },
      SETTINGS (state, { field, value }) {
        Vue.set(state.settings, field, value)
      },
      SET_SETTING (state, { field, value }) {
        Vue.set(state.settings, field, value)
      },
      SAVE_SETTINGS (state, payload) {
        Vue.set(state, 'settings', payload)
      },
      SETTINGS_RESET (state) {
        Vue.set(state, 'settings', defaultSettings)
      },
      LAYOUT (state, value) {
        Vue.set(state.settings, 'layout', value)
      },
      FETCH_ALL (state, data) {
        Vue.set(state, 'records', data)
      },
      EXCEL_DOWN (state, url) {
        Vue.set(state, 'excelUrl', url)
      },
      EXCEL_DOWN_PRETTY (state, url) {
        Vue.set(state, 'excelPrettyUrl', url)
      },
      GUEST_DATA (state, option) {
        Vue.set(state, 'guestData', option)
      },
      UNAPPROVED_DATA (state, option) {
        Vue.set(state, 'unapprovedData', option)
      },
      API_INSERT (state, data) {
        const { id } = data
        if (id) {
          const recordIndex = state.records.findIndex(record => record.id === id)
          if (recordIndex === -1) {
            state.records.push(data)
          } else {
            Vue.set(state.records, recordIndex, data)
          }
        } else {
          state.records.push(data)
        }
      },
      API_DESTROY (state, id) {
        const index = state.records.findIndex(r => r.id === id)
        if (index !== -1) {
          state.records.splice(index, 1)
        }
      },
      API_UPDATE (state, { id, updates }) {
        const index = state.records.findIndex(r => r.id === id)
        Vue.set(state.records, index, updates)
      }
    },
    mutations
  )

export default createMutations
